import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  xs
} from "./chunk.QLZDQDDJ.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/footer/footer.styles.ts
var footer_styles_default = r` ${component_mobile_styles_default} .footer { font-family: var(--sl-font-sans); text-align: center; padding-top: var(--sl-spacing-x-large); padding-bottom: var(--sl-spacing-x-large); } .footer--default { color: var(--footer-color-default); background: var(--footer-background-default); } .footer--primary { color: var(--footer-color-primary); background: var(--footer-background-primary); } .footer--transparent { color: var(--footer-color-transparent); background: var(--footer-background-transparent); } .footer--has-copyright.footer--has-items .footer__copyright { padding-top: var(--sl-spacing-small); } .footer__copyright-default { color: var(--footer-copyright-default); } .footer__copyright-primary { color: var(--footer-copyright-primary); } .footer__copyright-transparent { color: var(--footer-copyright-transparent); } ${xs(r` .footer { padding-top: var(--sl-spacing-large); padding-bottom: var(--sl-spacing-large); } `)} `;

export {
  footer_styles_default
};
